export async function CaptureAdminApproval(invite_token, admin_invite_action) {

    const raw = JSON.stringify({
        invite_token: invite_token,
        admin_invite_action: admin_invite_action,
    });

    const requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: {"Content-Type": "application/json"},
    };

    try {
        const response = await fetch(
            process.env.REACT_APP_CAPTURE_ADMIN_APPROVAL_API,
            requestOptions
        );

        const message = await response.json();

        if (!response.ok) {
            return { status: response.status, error: message.error || message };
        } else {
            return { status: response.status, result: message.result };
        }
    } catch (error) {
        return { status: 0, error: error.message };
    }
}
